import { useEffect, useMemo, useState } from 'react';

import { useIsMobile } from './useIsMobile';

export function useResponsivePanel() {
  const isMobile = useIsMobile();

  const [viewport, setViewport] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useEffect(() => {
    const handleResize = () => {
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const bounds = useMemo(() => {
    const padding = 16;
    return {
      minX: padding,
      minY: padding,
      maxX: viewport.width - padding,
      maxY: viewport.height - padding,
    };
  }, [viewport]);

  return {
    isMobile,
    viewport,
    bounds,
  };
}
